// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as React$1 from "motion/react";
import * as TailwindMerge from "tailwind-merge";
import * as Motion$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/Motion.res.mjs";
import * as V3RefManager$LiteracyplanetTupperware from "./V3RefManager.res.mjs";
import * as V3ProgressBar$LiteracyplanetTupperware from "./V3ProgressBar.res.mjs";
import * as V3TutorialContext$LiteracyplanetTupperware from "./V3TutorialContext.res.mjs";
import * as AudioEmbeddedComponent$LiteracyplanetTupperware from "../v2/AudioEmbeddedComponent.res.mjs";
import * as V3AudioEmbeddedComponent$LiteracyplanetTupperware from "./V3AudioEmbeddedComponent.res.mjs";

function V3Tutorial$Skilful(props) {
  var sources = props.sources;
  var match = V3TutorialContext$LiteracyplanetTupperware.use();
  var onFinishedReading = match.onFinishedReading;
  var state = match.state;
  return React.createElement("div", undefined, React.createElement("div", {
                  className: TailwindMerge.twMerge(state !== "ReadingTutorial" ? "hidden" : "", "relative"),
                  id: "tutorial"
                }, props.hasWords ? React.createElement("div", undefined, React.createElement(V3RefManager$LiteracyplanetTupperware.MakeRefContainer.make, {
                            id: "tutorialWordsTitle",
                            className: "pilot-title",
                            children: null
                          }), React.createElement(V3RefManager$LiteracyplanetTupperware.MakeRefContainer.make, {
                            id: "tutorialWordsContainer",
                            className: "flex gap-5",
                            children: null
                          })) : null, React.createElement("div", {
                      className: ""
                    }, React.createElement("div", undefined, sources !== undefined ? React.createElement(AudioEmbeddedComponent$LiteracyplanetTupperware.make, {
                                audioId: "??",
                                sources: sources,
                                autoPlay: false
                              }) : null, React.createElement(V3RefManager$LiteracyplanetTupperware.MakeRefContainer.make, {
                              id: "tutorialTitle",
                              children: null
                            })), React.createElement("div", {
                          className: ""
                        }, React.createElement(V3RefManager$LiteracyplanetTupperware.MakeRefContainer.make, {
                              id: "tutorialBody",
                              children: null
                            }))), React.createElement("button", {
                      className: "",
                      onClick: (function (param) {
                          onFinishedReading();
                        })
                    }, "Start the lesson activities now")), React.createElement("div", {
                  className: TailwindMerge.twMerge(state === "ReadingTutorial" ? "hidden" : "", "relative"),
                  id: "tutorialQuestions"
                }, props.children));
}

var Skilful = {
  make: V3Tutorial$Skilful
};

function V3Tutorial$ScrollableQuestions(props) {
  var ref = React.useRef(null);
  var match = React$1.useScroll({
        container: ref
      });
  var scrollYProgress = match.scrollYProgress;
  if (scrollYProgress !== undefined) {
    var scaleX = React$1.useSpring(Caml_option.valFromOption(scrollYProgress), {
          stiffness: 100,
          damping: 30,
          restDelta: 0.001
        });
    return React.createElement("div", {
                ref: Caml_option.some(ref),
                className: "absolute top-0 left-0 overflow-y-scroll h-screen snap-y snap-mandatory",
                id: "questions"
              }, React.createElement(V3ProgressBar$LiteracyplanetTupperware.make, {
                    scaleX: scaleX
                  }), props.children);
  }
  throw {
        RE_EXN_ID: "Match_failure",
        _1: [
          "V3Tutorial.res",
          68,
          4
        ],
        Error: new Error()
      };
}

var ScrollableQuestions = {
  make: V3Tutorial$ScrollableQuestions
};

function V3Tutorial(props) {
  var match = V3TutorialContext$LiteracyplanetTupperware.use();
  var onSetReadingTutorial = match.onSetReadingTutorial;
  var onFinishedReading = match.onFinishedReading;
  var state = match.state;
  var match$1 = React$1.useAnimate();
  var animate = match$1[1];
  React.useEffect((function () {
          onSetReadingTutorial();
        }), []);
  var showQuestions = function () {
    var run = async function () {
      animate("#tutorial", {
            top: "-100%"
          }, {
            duration: 0.3
          });
      await animate("#tutorialQuestions", {
            top: "-100%"
          }, {
            duration: 0.3
          });
    };
    run();
  };
  var showTutorial = function () {
    var run = async function () {
      animate("#tutorialQuestions", {
            top: 0
          }, {
            duration: 0.3,
            ease: "linear"
          });
      await animate("#tutorial", {
            top: 0
          }, {
            duration: 0.3,
            ease: "linear"
          });
    };
    run();
  };
  return React.createElement("div", {
              ref: Caml_option.some(match$1[0]),
              className: "absolute top-0 left-0 w-screen h-screen"
            }, React.createElement("div", {
                  className: "pilot-tutorial-page",
                  id: "tutorial"
                }, React.createElement("div", {
                      className: "pilot-tutorial-container max-h-[90vh]"
                    }, React.createElement("div", {
                          className: "pilot-tutorial-header pilot-heading2"
                        }, React.createElement(V3RefManager$LiteracyplanetTupperware.MakeRefContainer.make, {
                              id: "tutorialTitle",
                              className: "col-span-2",
                              children: null
                            })), React.createElement("div", {
                          className: "pilot-tutorial-body"
                        }, React.createElement(V3RefManager$LiteracyplanetTupperware.MakeRefContainer.make, {
                              id: "tutorialBody",
                              children: null
                            }, null, React.createElement(V3AudioEmbeddedComponent$LiteracyplanetTupperware.WithButtonAndSources.make, {
                                  audioId: "v3Tutorial",
                                  sources: props.sources
                                }))), props.hasWords ? React.createElement("div", {
                            className: "pilot-word-list-container"
                          }, React.createElement("div", {
                                className: "pilot-word-list-title"
                              }, React.createElement(V3RefManager$LiteracyplanetTupperware.MakeRefContainer.make, {
                                    id: "tutorialWordsTitle",
                                    children: null
                                  })), React.createElement(V3RefManager$LiteracyplanetTupperware.MakeRefContainer.make, {
                                id: "tutorialWordsContainer",
                                className: "pilot-word-list-words",
                                children: null
                              })) : null), React.createElement("button", {
                      className: "pilot-link justify-self-center text-lg hover:underline",
                      onClick: (function (param) {
                          onFinishedReading();
                          showQuestions();
                        })
                    }, "Start the lesson activities now")), React.createElement("div", {
                  className: TailwindMerge.twMerge(state === "ReadingTutorial" ? "hidden" : "", "relative"),
                  id: "tutorialQuestions"
                }, React.createElement(V3RefManager$LiteracyplanetTupperware.PortalImmediate.make, {
                      id: "showTutorialButton",
                      children: state === "ReadingTutorial" ? null : React.createElement(Motion$LiteracyplanetClientFlags.Div.make, {
                              initial: {
                                transform: "translateY(-100%)"
                              },
                              animate: {
                                transform: "translateY(0px)"
                              },
                              transition: {
                                type: "spring",
                                duration: 1
                              },
                              className: "",
                              children: Caml_option.some(React.createElement("button", {
                                        className: "pilot-lesson-button",
                                        onClick: (function (param) {
                                            onSetReadingTutorial();
                                            showTutorial();
                                          })
                                      }, "Tutorial"))
                            })
                    }), React.createElement(V3Tutorial$ScrollableQuestions, {
                      children: props.children
                    })));
}

var Motion;

var make = V3Tutorial;

export {
  Motion ,
  Skilful ,
  ScrollableQuestions ,
  make ,
}
/* react Not a pure module */
